export default "/images/10bb3b6fea3a1b411056cf0ae96431c8.avif";